// mds-dojo — dijit/CheckedMenuItem — FAITHFUL port of references/dijit/CheckedMenuItem.js.
// A checkbox-like menu item for toggling on and off. declare from the faithful runtime;
// template ?raw. Side-effect `./hccss` import (high-contrast detection) and unused
// domClass import dropped.
import declare from '../dojo/_base/declare-runtime'; // declare
import MenuItem from './MenuItem';
import template from './templates/CheckedMenuItem.html?raw';

export default declare('dijit.CheckedMenuItem', MenuItem, {
  // summary:
  //		A checkbox-like menu item for toggling on and off

  // Use both base classes so we get styles like dijitMenuItemDisabled
  baseClass: 'dijitMenuItem dijitCheckedMenuItem',

  templateString: template,

  // checked: Boolean
  //		Our checked state
  checked: false,
  _setCheckedAttr: function (/*Boolean*/ checked: any) {
    this.domNode.setAttribute('aria-checked', checked ? 'true' : 'false');
    this._set('checked', checked);	// triggers CSS update via _CssStateMixin
  },

  iconClass: '',	// override dijitNoIcon

  role: 'menuitemcheckbox',

  // checkedChar: String
  //		Character (or string) used in place of checkbox icon when display in high contrast mode
  checkedChar: '&#10003;',

  onChange: function (/*Boolean*/ /*===== checked =====*/) {
    // User defined function to handle check/uncheck events
  },

  _onClick: function (evt: any) {
    // Clicking this item just toggles its state
    if (!this.disabled) {
      this.set('checked', !this.checked);
      this.onChange(this.checked);
    }
    this.onClick(evt);
  },
});
